<div class="m-t-8 quick-filter-box">
  <div class="applied-filter-holder" style="display: flex; flex-wrap: wrap; align-items: center; gap: 6px">
    @for (taggedFilter of taggedFilters; track trackByKey($index, taggedFilter)) {
      <!-- Filter Label -->
      <div class="filter-label" style="margin-right: 4px">{{ taggedFilter.key }}:</div>
      <!-- Region Codes -->
      @if (taggedFilter.key === 'Region' && getTaggedRegionCodes().length) {
        <app-tag-with-overflow [data]="getTaggedRegionCodes()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectRegion()">
        </app-tag-with-overflow>
      }
      <!-- Cluster/Area Codes -->
      @if (taggedFilter.key === 'Cluster' && getTaggedAreaCodes().length) {
        <app-tag-with-overflow [data]="getTaggedAreaCodes()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectCluster()">
        </app-tag-with-overflow>
      }
      <!-- Country Codes -->
      @if (taggedFilter.key === 'Country' && getTaggedCountryCodes().length) {
        <app-tag-with-overflow [data]="getTaggedCountryCodes()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectCountry()">
        </app-tag-with-overflow>
      }
      <!-- Shop Codes -->
      @if (taggedFilter.key === 'Shop Code' && getTaggedShopCodes().length) {
        <app-tag-with-overflow [data]="getTaggedShopCodes()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectShopCode()">
        </app-tag-with-overflow>
      }
      <!-- Repair Modes -->
      @if (taggedFilter.key === 'Repair Mode' && getTaggedRepairModes().length) {
        <app-tag-with-overflow [data]="getTaggedRepairModes()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectRepairMode()">
        </app-tag-with-overflow>
      }
      <!-- Repair Codes -->
      @if (taggedFilter.key === 'Repair Code' && getTaggedRepairCodes().length) {
        <app-tag-with-overflow [data]="getTaggedRepairCodes()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectRepairCode()">
        </app-tag-with-overflow>
      }
      <!-- Expiry Date (Single Tag) -->
      @if (taggedFilter.key === 'Expiry Date' && getTaggedExpiryDate()) {
        <mc-tag class="m-r-4 extra-height" appearance="neutral-inverse" fit="small" withaction (dismiss)="unselectExpiryDate()()">
          {{ getTaggedExpiryDate() }}
        </mc-tag>
      }
      <!-- Default fallback -->
      @if (
        taggedFilter.key !== 'Region' &&
        taggedFilter.key !== 'Cluster' &&
        taggedFilter.key !== 'Country' &&
        taggedFilter.key !== 'Shop Code' &&
        taggedFilter.key !== 'Repair Mode' &&
        taggedFilter.key !== 'Repair Code' &&
        taggedFilter.key !== 'Expiry Date'
      ) {
        <app-tag-with-overflow
          [data]="getFilterValueArray(taggedFilter)"
          [overflowCount]="1"
          [withaction]="true"
          (dismiss)="unselectArrayFilter(taggedFilter, $any($event))">
        </app-tag-with-overflow>
      }
    }

    <!-- Clear All -->
    @if (taggedFilters.length) {
      <mc-button
        class="clear-btn"
        variant="plain"
        appearance="primary"
        fit="small"
        padding="default"
        (click)="clearAllSelectedFilters()"
        (keydown)="clearAllSelectedFilters()">
        Clear All
      </mc-button>
    }
  </div>

  <!-- Utility Buttons -->
  <div class="utility-buttons">
    @if (authPolicies.canViewShopContract) {
      <mc-button
        class="utility-button"
        icon="tray-arrow-down"
        variant="filled"
        appearance="neutral"
        fit="medium"
        [loading]="isDownload"
        hiddenlabel
        padding="default"
        (click)="onDownload()"
        (keydown)="onDownload()">
      </mc-button>
    }
    <mc-button
      class="utility-button-inner"
      slot="trigger"
      icon="sliders-horizontal"
      variant="filled"
      appearance="neutral"
      hiddenlabel
      padding="default"
      fit="medium"
      (click)="showAdvanceFiltersModal()"
      (keydown)="showAdvanceFiltersModal()">
    </mc-button>
  </div>
</div>

<!-- Advanced Filters Modal -->
<mc-modal
  backdropcloseactiondisabled
  [open]="showAdvanceFilters"
  (closed)="closeAdvanceFiltersModal()"
  heading="Filters"
  fit="small"
  dimension="large">
  <app-material-rate-advanced-filters [materialRatesFilterForm]="filterFormGroup" [isGSCUser]="isGSCUser" [allShops]="allShops">
  </app-material-rate-advanced-filters>
</mc-modal>
